import React from 'react';
import { Wrapper, Dot } from './Loader.styles';

const Loader = () => (
  <Wrapper>
    <Dot />
    <Dot />
    <Dot />
    <Dot />
  </Wrapper>
);

export default Loader;
